import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, ownerOnly = false, roles }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen app-bg flex items-center justify-center">
                <div className="flex items-center gap-3" style={{ color: "var(--text-secondary)" }}>
                    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--apple-blue)" }} />
                    <span>Memuat sesi...</span>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (ownerOnly && !user.is_owner) return <Navigate to="/dashboard" replace />;
    // Legacy `roles` prop → treat as ownerOnly if any role equals "admin"
    if (roles && Array.isArray(roles) && roles.includes("admin") && !user.is_owner) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};
